/**
 * The content id that indicates new content.
 *
 * @const {string}
 */
export const CONTENT_NEW = 'new';
